import {
  getFileSignedURLThunk,
  getFileROWSignedURLThunk,
} from "@modules/stepper/redux/thunk/documentThunk";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getSignedPreviewUrl } from "../../../utils/getViewSignedUrlHandler";

const LicenseDocuments = ({ drawingFile }: any) => {
  const dispatch = useDispatch();

  // store signed urls mapped by document id
  const [signedUrls, setSignedUrls] = useState<Record<string, string>>({});
  const [blobUrls, setBlobUrls] = useState<Record<string, string>>({});

  const fetchedRef = useRef<Set<string>>(new Set());

  const generateBlobUrl = async (
    doc_name: string,
    docId: string,
    module_type: string,
  ) => {
    try {
      // ✅ skip if already fetched
      if (fetchedRef.current.has(docId)) return;

      const signedUrl = await getSignedPreviewUrl({
        document_name: doc_name,
        dispatch,
        getSignedUrlThunk:
          module_type === "row"
            ? getFileROWSignedURLThunk
            : getFileSignedURLThunk,
      });

      if (!signedUrl) return;

      const response = await fetch(signedUrl);
      const blob = await response.blob();

      const blobUrl = URL.createObjectURL(blob);

      fetchedRef.current.add(docId); // ✅ mark fetched

      setBlobUrls((prev) => ({
        ...prev,
        [docId]: blobUrl,
      }));
    } catch (e) {
      console.error("Failed to generate blob URL", e);
    }
  };

  const generateSignedUrl = async (
    doc_name: string,
    docId: string,
    module_type: string,
  ) => {
    try {
      const signedUrl = await getSignedPreviewUrl({
        document_name: doc_name,
        dispatch,
        getSignedUrlThunk:
          module_type === "row"
            ? getFileROWSignedURLThunk
            : getFileSignedURLThunk,
      });
      if (!signedUrl) return;

      setSignedUrls((prev) => ({
        ...prev,
        [docId]: signedUrl,
      }));
    } catch (e) {
      console.error("Failed to generate signed URL", e);
    }
  };

  // generate signed urls when drawingFile changes
  useEffect(() => {
    if (!drawingFile || drawingFile.length === 0) return;

    drawingFile.forEach((doc: any) => {
      const objectKey = doc.upload_path.replace(
        /^(noc-document|morth-documents)\/(row|access)\//,
        "",
      );
      generateBlobUrl(objectKey, doc.id, doc.module_type);
    });
  }, [drawingFile]);

  useEffect(() => {
    return () => {
      Object.values(blobUrls).forEach((url) => URL.revokeObjectURL(url));
    };
  }, []);

  return (
    <>
      {drawingFile?.length > 0 &&
        drawingFile?.map((doc: any) => (
          <div key={doc?.id} style={{ padding: 2, marginBottom: 2 }}>
            {blobUrls[doc?.id] ? (
              <embed
                width="100%"
                height="1000px"
                src={blobUrls[doc?.id]} // ✅ SIGNED URL HERE
                type="application/pdf"
              />
            ) : (
              <div
                style={{
                  height: "600px",
                  background: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#999",
                }}
              >
                Loading documents preview...
              </div>
            )}
          </div>
        ))}
    </>
  );
};

export default LicenseDocuments;
